import styled from "styled-components";


export const InfoContainer = styled.div`
height: 750px;
background: transparent;

width: 100%;
@media screen and (max-width: 1480px) {
    height: 600px;
    }

    @media screen and (max-width: 1115px) {
    height: 450px;
    }
    @media screen and (max-width: 820px) {
    height: 500px;
    }


@media screen and (max-width: 768px) {
    height: 800px;
    margin-top: 150px;
}
`

export const InfoWrapper = styled.div`
    display: grid;
    height: auto;
    width: 100%;
    max-width: 1100px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 20px;
    justify-items: center;
    z-index: 20;
    
`

export const InfoRow = styled.div`
    
    display: grid;
    grid-auto-columns: minmax(auto, 2fr);
    align-items: center;
    justify-items: center;
    margin: auto 5%;
    grid-template-areas: ${({imgStart}) => 
    (imgStart? `'col2 col1'` : `'col1 col2'`)};

    @media screen and (max-width: 768px) {
    grid-template-areas: ${({imgStart}) => 
    (imgStart? `'col1' 'col2'`: `'col1 col1' 'col2 col2'`)};
    }
`

export const Column1 = styled.div`
    margin-bottom: 15px;
    padding: 0;
    grid-area: col1;
    
`

export const Column2 = styled.div`
    
    padding:  0 15px;
    grid-area: col2;
    transform: translate(-15vw, 10%);
    
    @media screen and (max-width: 768px) {
    transform: translate(0);
    margin-bottom: 15px;
    }
`

export const TextWrapper = styled.div`
    max-width: 540px;
    display: flex;
    
    
    justify-content: center;
    text-align: left;
    
`

export const TopLine = styled.p`
    font-weight: 100;
    display: flex;
    justify-content: center;
    color: #fff;
    font-size: 60px;
    line-height: 100%;
    
    letter-spacing: 1.4px;
    text-transform: uppercase;
    margin-bottom: 0%;
    text-align: center;
    font-family: 'Gemunu Libre', sans-serif;

    @media screen and (max-width: 768px) {
    font-size: 2em;
}
`

export const Subtitle = styled.p`
    max-width: 540px;
    margin-top: 20%;
    font-size: 23px ;
    line-height: 35px;
    color: ${({darkText}) => (darkText ? '#010606' : "#fff")};
    font-family: 'Titillium Web', sans-serif;

    @media screen and (max-width: 1480px) {
    font-size: 20px;
    line-height: 30px;
    }

    @media screen and (max-width: 1115px) {
    font-size: 18px;
    line-height: 28px;
    }

    @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 23px;
    margin-bottom: 50px;
    text-align: center;
    }
`

export const ImgWrap = styled.div`
    max-width: 555px;
    height: 100%;
    margin-bottom: 50px;
    margin-left: 30%;

    @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    overflow: hidden;
}
`